import { useEffect, useMemo, useState } from "react"
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import AddIcon from '@mui/icons-material/Add';
import TextField from '@mui/material/TextField';
import Option from "./Option";
import Badge from '@mui/material/Badge';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
import AppBar from '@mui/material/AppBar';
import ProductPlaceholder from '../../../../images/product_placeholder.webp'
import { useRef } from "react";
import Styles from './Styles/Product.module.css'
import { OPTIONS_VARIANTS } from "../../../../utils/structures";

export default function Product(props) {

    const [prodImg, setProdImg] = useState(undefined)
    const [infoOpen, setInfoOpen] = useState(false);
    const [productOrder, setProductOrder] = useState({})
    const [productOptions, setProductOptions] = useState([])
    const [productCount, setProductCount] = useState(1)
    const [note, setNote] = useState('')

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const [mandatoryOptionsStates, setMandatoryOptionsStates] = useState({})
    const mandatoryOptions = useMemo(() => props.product[1].options ?
        props.product[1].options.filter(option => option.isMandatory)
            .map(option => {
                return {
                    name: option.name,
                    isCompleted: false,
                    // Por si pusieron obligatorias mas opciones de las que hay para elegir
                    elegibleOptions: option.type === OPTIONS_VARIANTS.addUnits ? option.elegibleOptions : Math.min(option.elegibleOptions, option.subOptions.length),
                    type: option.type
                }
            }) : []
        , [props.product])


    const mandatoryOptionsRef = useRef([]);

    useEffect(() => {
        let newStates = mandatoryOptions
        for (let i = 0; i < mandatoryOptions.length; i++) {

            let founded = false
            for (let k = 0; k < productOptions.length; k++) {

                if (mandatoryOptions[i].name === productOptions[k].name) {
                    //encontre la opcion segun el tipo hay diferentes condiciones para que este completa
                    founded = true

                    if (mandatoryOptions[i].type === OPTIONS_VARIANTS.addUnits) {
                        const addUnitsTotal = productOptions[k].subOptions.reduce((prev, curr) => prev + curr.units, 0)

                        if (parseInt(mandatoryOptions[i].elegibleOptions) === addUnitsTotal) {
                            newStates[i].isCompleted = true
                        } else {
                            newStates[i].isCompleted = false
                        }

                    } else if (mandatoryOptions[i].type === OPTIONS_VARIANTS.selectOption
                        && mandatoryOptions[i].elegibleOptions === productOptions[k].subOptions.length) {
                        newStates[i].isCompleted = true

                    } else {
                        newStates[i].isCompleted = false
                    }

                    break
                }
            }

            if (!founded) {
                newStates[i].isCompleted = false
            }
        }

        setMandatoryOptionsStates(newStates)

    }, [productOptions])

    const isImg = (image) => {
        return new Promise((resolve) => {
            const fileReader = new FileReader();
            fileReader.onloadend = () => {
                // Verificamos si el tipo de archivo es una imagen
                if (fileReader.result && fileReader.result.startsWith("data:image")) {
                    resolve(true);
                } else {
                    resolve(false);
                }
            };
            fileReader.readAsDataURL(image);
        });
    };

    const setImg = async () => {
        const aux = await props.getProductImg(props.product)

        if (await isImg(aux)) {
            const img = URL.createObjectURL(aux)

            setProdImg(img)
            setProductOrder(prev => {
                let aux = prev
                aux.image = img
                return aux
            })
        }
    }

    const addProduct = () => {
        props.addProductToOrder(productOrder)
        handleClose()
    }

    const addProductIfCompleted = () => {
        let optionCompleted = true
        for (let i = 0; i < mandatoryOptionsStates.length; i++) {

            if (!mandatoryOptionsStates[i].isCompleted) {
                optionCompleted = false
                scrollToContent(i)
                break
            }
        }

        if (optionCompleted) {
            addProduct()
        }
    };

    const scrollToContent = (index) => {
        const contentRef = mandatoryOptionsRef.current[index];

        if (contentRef) {
            contentRef.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
                inline: 'nearest',
            });
        }
    };

    const handleClose = () => {
        setProductOrder({})
        setProductOptions([])
        setInfoOpen(false)
        setProductCount(1)
        setNote('')
        setMandatoryOptionsStates(mandatoryOptions)
    }

    useEffect(() => {
        setImg()

        setProductOrder({
            id: props.product[0],
            name: props.product[1].name,
            count: productCount,
            image: prodImg,
            price: props.offer ? (props.product[1].price - props.offer.priceChange * props.product[1].price).toFixed(2) : props.product[1].price,
            options: [],
            note: ''
        })

        mandatoryOptionsRef.current = mandatoryOptionsRef.current.slice(0, mandatoryOptions.length);
    }, [])

    useEffect(() => {
        let extraPrice = 0
        for (let i = 0; i < productOptions.length; i++) {
            if (productOptions[i].type === OPTIONS_VARIANTS.selectOption) {

                for (let j = 0; j < productOptions[i].subOptions.length; j++) {
                    extraPrice += parseFloat(productOptions[i].subOptions[j].price)
                }
            } else {

                for (let j = 0; j < productOptions[i].subOptions.length; j++) {
                    extraPrice += parseFloat(productOptions[i].subOptions[j].price * productOptions[i].subOptions[j].units)
                }
            }
        }

        setProductOrder({
            id: props.product[0],
            name: props.product[1].name,
            count: productCount,
            image: prodImg,
            price: props.offer ? (props.product[1].price - props.offer.priceChange * props.product[1].price).toFixed(2) : props.product[1].price,
            extraPrice: extraPrice,
            options: productOptions,
            note: note
        })
    }, [productOptions])

    useEffect(() => {
        setProductOrder(prev => {
            let aux = { ...prev }
            aux.count = productCount
            aux.note = note
            return aux
        })
    }, [productCount, note])

    return (
        <>
            <div
                className={props.featuredVersion ? Styles.featuredContainer : Styles.container}
                style={{ boxShadow: '0px 0px 15px ' + (props.color >= 0 ? 'hsl(' + props.color + ',100%, 93%)' : 'hsl(0, 0%, 93%)') }}
                onClick={setInfoOpen.bind(this, true)}
            >

                <div className={props.featuredVersion ? null : Styles.data}>

                    <Typography className={Styles.name} style={{ WebkitLineClamp: props.featuredVersion ? 1 : 2 }}>
                        <b>{props.product[1].name}</b>
                    </Typography>

                    {props.featuredVersion ? null : <Typography variant="body2" className={Styles.caption}>{props.product[1].caption}</Typography>}

                    <Stack direction={props.featuredVersion ? 'column' : 'row'} spacing={props.featuredVersion ? 0 : 1}>

                        {props.offer ?
                            <>
                                <Typography fontWeight='700' fontSize='1.1em' >${(props.product[1].price - props.offer.priceChange * props.product[1].price).toFixed(2)}</Typography>

                                <Badge badgeContent={'-' + props.offer.priceChange * 100 + '%'}
                                    color="error"
                                    anchorOrigin={props.featuredVersion ?
                                        {
                                            vertical: 'bottom',
                                            horizontal: 'left',
                                        } :
                                        {
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                >
                                    <Typography sx={{ textDecoration: 'line-through' }} >${props.product[1].price}</Typography>
                                </Badge>
                            </> :
                            <Typography fontWeight='700' fontSize='1.1em' >${props.product[1].price}</Typography>}

                    </Stack>

                </div>

                {props.featuredVersion ?
                    <div style={{ position: 'relative', alignSelf: 'flex-end' }}>
                        <AddIcon className={Styles.addButton} />
                    </div> : null}

                {props.featuredVersion ?
                    prodImg ?
                        <div className={Styles.featuredImgContainer} style={{ backgroundImage: 'url(' + prodImg + ')' }}></div> :
                        <div className={Styles.featuredImgContainer} style={{ backgroundImage: 'url(' + ProductPlaceholder + ')' }}></div>
                    :
                    <>
                        {prodImg ? <div className={Styles.productImgContainer} style={{ backgroundImage: 'url(' + prodImg + ')' }}>
                            <AddIcon className={Styles.addButton} />
                        </div> :
                            <div className={Styles.noImageAddButton}>
                                <AddIcon className={Styles.addButton} />
                            </div>}
                    </>}

            </div>

            <Dialog
                fullScreen={fullScreen}
                fullWidth={true}
                maxWidth="sm"
                open={infoOpen}
                onClose={handleClose.bind(this)}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogTitle id="responsive-dialog-title" variant="h5" fontWeight='700'>

                    <Stack direction='row' justifyContent='space-between' alignItems='center'>

                        {props.product[1].name}
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={() => setInfoOpen(false)}
                        >
                            <CloseIcon />
                        </IconButton>

                    </Stack>

                </DialogTitle>

                <DialogContent sx={{ p: 0 }} >

                    {prodImg ?
                        <div className={Styles.fullImgContainer}
                            style={{ backgroundImage: 'url(' + prodImg + ')' }}></div>
                        : null}

                    <Stack sx={{ padding: '20px 20px 80px 20px' }}>

                        {props.product[1].calories === 0 ? null :
                            <Typography fontWeight={500}>Aproximadamente {props.product[1].calories} Kcal</Typography>}

                        {props.product[1].caption === '' ? null :
                            <>
                                <Typography variant="h6">Descripción</Typography>
                                <Typography variant="body2">{props.product[1].caption}</Typography>
                            </>}

                        <Stack>
                            {!props.product[1].options ? null :
                                props.product[1].options.map((option, index) => {
                                    return <div key={index} ref={el => mandatoryOptionsRef.current[index] = el} >
                                        <Option
                                            option={option}
                                            productOrder={productOrder}
                                            productOptions={productOptions}
                                            setProductOptions={setProductOptions}
                                        />
                                    </div>
                                })
                            }
                        </Stack>

                        <Divider sx={{ m: 1 }} />

                        <Typography variant="h6">Agregar instrucciones extra</Typography>
                        <TextField
                            multiline
                            value={note}
                            onChange={e => setNote(e.target.value)}
                            sx={{ m: 1 }}
                            helperText='Maximo 500 caracteres'
                            placeholder="Agrega detalles de tu pedido que el negocio debería saber (Ej. Alergia a comidas, quitar ingredientes, etc)"
                        />
                    </Stack>

                </DialogContent>

                <AppBar position="relative" color="text">
                    <Stack direction='row' justifyContent='space-evenly' alignItems='center' sx={{ m: 1 }}>

                        <Stack direction='row' justifyContent='center' alignItems='center' spacing={1}>

                            <IconButton onClick={productCount === 1 ? null : () => setProductCount(prev => prev - 1)}>
                                <RemoveCircleOutlineOutlinedIcon />
                            </IconButton>

                            <Typography variant="h6">{productCount}</Typography>

                            <IconButton onClick={() => setProductCount(prev => prev + 1)}>
                                <AddCircleOutlineOutlinedIcon />
                            </IconButton>

                        </Stack>

                        <Button variant="contained" onClick={() => addProductIfCompleted()} sx={{ borderRadius: '20px' }} color="error"
                            disabled={!props.storeIsOpen}>

                            {props.storeIsOpen ?
                                <>Agregar ${productOrder ? ((productOrder.price + productOrder.extraPrice) * productCount).toFixed(2) : 0}</> :
                                <>Negocio cerrado</>}

                        </Button>

                    </Stack>
                </AppBar>
            </Dialog>
        </>
    )
}

